const
    configurations = {
        baseUrl: process.env.REACT_APP_BASE_URL,
        enrollmentURL : process.env.REACT_APP_ENROLLMENT_URL,
        AGENT_BASE_URL : process.env.REACT_APP_AGENT_URL,
    }

export default configurations;